export default __webpack_public_path__ + "0f0a7cc.png";